import {
  EVENT_FIELD_VERIFICATION_CONCLUSION_KEYWORD,
  EVENT_FIELD_VERIFICATION_CONCLUSION_REASON_KEYWORD,
} from '../../../../constants';
import { type FieldStat } from '../platform/platform';

const HARDCODED_FIELD_STATS = [
  {
    docCount: 1,
    name: 'startTime',
    type: 'date',
  },
  {
    docCount: 1,
    name: 'endTime',
    type: 'date',
  },
  {
    docCount: 1,
    name: 'pushToCloudStatus',
    type: 'enum',
  },
  {
    docCount: 1,
    name: 'startTimeHrMin',
    type: 'integer',
  },
  {
    docCount: 1,
    name: 'endTimeHrMin',
    type: 'integer',
  },
  {
    docCount: 1,
    name: EVENT_FIELD_VERIFICATION_CONCLUSION_KEYWORD,
    type: 'string',
  },
  {
    docCount: 1,
    name: EVENT_FIELD_VERIFICATION_CONCLUSION_REASON_KEYWORD,
    type: 'string',
  },
];

/**
 * Adds hardcoded field stats to the list of field stats.
 * Some fields are not returned by the API because they are the root fields of the event.
 * Or they are not returned because they doesn't appear on the events the last 2 weeks
 * but are still important to always display.
 *
 * This function mutates the `fieldStats` array.
 *
 * @param fieldStats
 */
export function addHardcodedFieldStats(fieldStats: FieldStat[]) {
  HARDCODED_FIELD_STATS.forEach((fieldStat) => {
    if (!fieldStats.find((stat) => stat.name === fieldStat.name)) {
      fieldStats.push(fieldStat);
    }
  });
}
